import styled from 'styled-components';

export const CarouselVideoItemWrapper = styled.div`
  width: 310px;
  height: 435px;
`;
